import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { BaseLayoutComponent } from './views/share/base-layout/base-layout.component';

const routes: Routes = [
  {
    path: 'auth',
    loadChildren: () =>
      import('./views/auth/auth.module').then((m) => m.AuthModule),
  },
  {
    path: '',
    component: BaseLayoutComponent,
    loadChildren: () =>
      import('./views/user/user.module').then((m) => m.UserModule),
  },
  {
    path: 'scan',
    component: BaseLayoutComponent,
    loadChildren: () =>
      import('./views/scan/scan.module').then((m) => m.ScanModule),
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
